import { api } from "../api";
import { estado } from "../estado";
import { esc, CANDADO, toast } from "../ui";
import type { Vista } from "./tipos";

export function bloqueado(seccion: string): Vista {
  return {
    titulo: seccion, sub: "",
    html: '<div class="card" style="border-color:var(--warnBorder);background:var(--ground);padding:28px 30px;display:flex;gap:18px;align-items:flex-start"><div style="width:40px;height:40px;border-radius:10px;background:var(--warnBg);display:flex;align-items:center;justify-content:center;color:var(--warn2);flex-shrink:0">' + CANDADO + '</div><div><div style="font-size:16px;font-weight:620">No tienes acceso a ' + esc(seccion) + '</div><div style="font-size:13px;color:var(--warnText);margin-top:5px;line-height:1.55;max-width:560px">Todo usuario empieza sin acceso a ningún módulo y ningún cliente. Pídele a IT lo que necesites para trabajar y queda registrado quién te lo dio.</div><div style="display:flex;gap:9px;margin-top:15px"><button class="btn primario" id="bl-pedir">Solicitar acceso a IT</button><button class="btn" data-go="#/inicio">Volver a Inicio</button></div></div></div>',
    despues(root) {
      root.querySelector<HTMLButtonElement>("#bl-pedir")!.onclick = async (e) => {
        const b = e.currentTarget as HTMLButtonElement; b.disabled = true;
        const u = estado.usuario()!;
        try {
          await api.solicitar({ departamento: u.departamento || "—", clientes: "", queHara: "Acceso al módulo " + seccion });
          toast("<b>Ticket abierto para IT.</b> Lo verá en su bandeja de solicitudes.");
        } catch (ex) { toast("<b>No se pudo abrir el ticket.</b> " + esc((ex as Error).message)); b.disabled = false; }
      };
    },
  };
}

export function sinInfo(): Vista {
  return { titulo: "No hay información sobre eso", sub: "", html: '<div class="aviso warn">No existe o no está en tus cuentas. No se confirma cuál de las dos: confirmar que existe ya sería filtrar.</div>' };
}
